module.exports = __webpack_public_path__ + "fonts/HelveticaNeue-Bold.d518db4d.woff";